import classNames from 'classnames';
import { Search } from 'lucide-react';
import React from 'react';
import { ClipLoader } from 'react-spinners';
import { theme } from 'styles/theme/theme';
import UDInput from 'ud-form/components/input/component';
import Label from 'ud-ui/components/label';
import { DivProps } from 'typings';

const ICON_SIZE = 16;

interface UDSearchInputProps extends Omit<DivProps, 'placeholder' | 'onChange' | 'onBlur' | 'onSubmit'> {
  value?: string;
  placeholder?: string;
  /** Подпись над полем. Без неё поле рисуется без подписи. */
  label?: string;
  /** С какой стороны стоит лупа. По умолчанию справа. */
  iconPosition?: 'icon-left' | 'icon-right';
  /**
   * Идёт поиск: лупа сменяется спиннером на её месте.
   * Индикатор именно в поле, а не поверх выдачи — так видно, что запрос вызван
   * вводом, и результат не подменяется молча (IMGM-1408).
   */
  loading?: boolean;
  onChange?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onSubmit?: (value: string) => void;
  parser?: (value: string) => string;

  width?: string;
  backgroundColor?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

function UDSearchInput(props: UDSearchInputProps) {
  const {
    value,
    placeholder,
    label,
    iconPosition = 'icon-right',
    loading,
    onChange,
    width,
    backgroundColor,
    inputRef,
    onBlur,
    autoFocus,
    onSubmit,
    parser,
    ...rest
  } = props;

  const input = (
    <UDInput
      autoFocus={autoFocus}
      style={{ backgroundColor, width: '100%' }}
      value={value}
      placeholder={placeholder}
      parser={parser}
      iconProps={{
        position: iconPosition,
        component: loading ? (
          <ClipLoader size={ICON_SIZE} color={theme.colors.SurfaceRomanSilver30} />
        ) : (
          <Search size={ICON_SIZE} color={theme.colors.SurfaceRomanSilver30} />
        ),
      }}
      onChange={onChange}
      onSubmit={(event) => onSubmit?.(event.currentTarget.value)}
      onBlur={(event) => onBlur?.(event)}
      ref={inputRef}
    />
  );

  return (
    <div className={classNames('flex items-center justify-between')} {...rest}>
      <div style={{ width: width ? width : '100%' }}>{label ? <Label text={label}>{input}</Label> : input}</div>
    </div>
  );
}

export default UDSearchInput;
